var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverPointOctagon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.828 0a3 3 0 0 1 2.121.879l7.172 7.172A3 3 0 0 1 32 10.17v11.657a3 3 0 0 1-.879 2.121l-7.172 7.172a3 3 0 0 1-2.12.879H10.171a3 3 0 0 1-2.121-.879L.879 23.95A3 3 0 0 1 0 21.83V10.171A3 3 0 0 1 .879 8.05L8.05.879l.22-.2A3 3 0 0 1 10.17 0h11.657ZM2.293 22.535a1 1 0 0 1-.288-.608L2 10.172a1 1 0 0 1 .293-.707l7.172-7.172A1 1 0 0 1 10.172 2h11.656c.267.013.515.1.707.293l7.172 7.172a1 1 0 0 1 .293.707v11.656c-.013.267-.1.515-.293.707l-7.245 7.238a1 1 0 0 1-.535.222L10.172 30a1 1 0 0 1-.707-.293l-7.172-7.172Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverPointOctagon);
export default __webpack_public_path__ + "static/media/hover_point_octagon.97529a9c170309f709dbfca001cef224.svg";
export { ForwardRef as ReactComponent };